import { $ABTest } from '@lemon8/web-app-shared/atom';
import { DeepLinkBuildingProps, buildSchema } from './schema';
import { PageTrafficUtil } from 'shared/utils';
import { $SharingPageLevelTraffic, $RootTraffic } from 'shared/atoms';
import { useAtomValue } from 'jotai';
import { useMemo } from 'react';
import { RootTrafficUtil } from 'shared/utils/root-traffic-util';

export const SHARING_FB_PID = 'share_al_fb';

export const useFBActiveUrl = (schemaOption: DeepLinkBuildingProps): string => {
  const { versions } = useAtomValue($ABTest);
  const rootTraffic = useAtomValue($RootTraffic);
  const pageTraffic = useAtomValue($SharingPageLevelTraffic);

  return useMemo(() => {
    const schema = buildSchema({
      ...schemaOption,
    });

    const schemaURL = new URL(schema);

    schemaURL.searchParams.set('pid', SHARING_FB_PID);
    schemaURL.searchParams.set('ab_version', versions);

    schemaURL.searchParams.set(
      'amp_extra',
      JSON.stringify({
        traffic_type: rootTraffic.trafficPid,
        is_from_wap: 0,

        // share_user_id: rootTraffic.sharerUid,
        // share_device_id: rootTraffic.sharerDid,
        // share_time: rootTraffic.shareTime,
        _t: rootTraffic.sharerToken,
        share_platform: rootTraffic.sharePlatform || null,

        // share content extra
        ...RootTrafficUtil.getShareContentExtra(rootTraffic),

        // enter page extra
        ...PageTrafficUtil.getEnterPageExtra(pageTraffic),
      }),
    );

    return schemaURL.toString();
  }, [versions, rootTraffic, pageTraffic, schemaOption]);
};
